<div class="mb-4 relative">
    <label *ngIf="label" [for]="id" class="block text-sm font-medium text-slate-700 mb-1">
        {{ label }}
    </label>
    <div class="relative rounded-md shadow-sm">
        <div *ngIf="icon" class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <lucide-icon [name]="icon" class="h-5 w-5 text-slate-400"></lucide-icon>
        </div>

        <input [id]="id" [type]="currentType" [placeholder]="placeholder" [disabled]="disabled"
            [attr.readonly]="readonly ? true : null" [class]="getInputClasses()" [value]="value"
            (input)="onInput($event)" (blur)="onTouched()" />

        <div *ngIf="error" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <lucide-icon name="alert-circle" class="h-5 w-5 text-red-500"></lucide-icon>
        </div>

        <button *ngIf="type === 'password'" type="button" (click)="togglePassword()"
            class="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600 focus:outline-none">
            <lucide-icon [name]="showPassword ? 'eye-off' : 'eye'" class="h-5 w-5"></lucide-icon>
        </button>
    </div>

    <p *ngIf="error" class="mt-1 text-sm text-red-600">
        {{ error }}
    </p>
    <p *ngIf="hintText && !error" class="mt-1 text-sm text-slate-500">
        {{ hintText }}
    </p>
</div>